import React, { useState, useEffect } from "react";
import { MdUpload } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EditAboutContentApi, aboutContentApi } from "Services/allApi";

function AboutContent() {
  const [formData, setFormData] = useState({
    bg_image: "",
    heading: "",
    main_sub_heading: "",
    main_heading1: "",
    main_heading2: "",
    main_heading3: "",
    main_bottom_head: "",
    main_description_section1: "",
    main_description_read_more: "",
    image1: "",
    image2: "",
    image3: "",
    second_sub_head: "",
    second_main_head1: "",
    second_main_head2: "",
    second_main_head3: "",
    second_bg_image: "",
  offer_bg_image: "",
    offer_sub_head: "",
    offer_head: "",
    offer_head_two: "",
    btn_content: "",
    btn_link: "",
  });
  const [currentImages, setCurrentImages] = useState({
    bg_image: "", image1: "", image2: "", image3: "",   second_bg_image: "",
    offer_bg_image: "",
  });

  const [id, setId] = useState(null);


  useEffect(() => {
    
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await aboutContentApi(); // Replace with actual API call
      if (response && !response.error) {
        const data = response.data; // Assuming response is a single object
        setId(data.id);
        setFormData({
          ...formData,
          heading: data.heading || "",
          main_sub_heading: data.main_sub_heading || "",
          main_heading1: data.main_heading1 || "",
          main_heading2: data.main_heading2 || "",
          main_heading3: data.main_heading3 || "",
          main_bottom_head: data.main_bottom_head || "",
          main_description_section1: data.main_description_section1 || "",
          main_description_read_more: data.main_description_read_more || "",
          second_sub_head: data.second_sub_head || "",
          second_main_head1: data.second_main_head1 || "",
          second_main_head2: data.second_main_head2 || "",
          second_main_head3: data.second_main_head3 || "",
          offer_sub_head: data.offer_sub_head || "",
          offer_head: data.offer_head || "",
          offer_head_two: data.offer_head_two || "",
          btn_content: data.btn_content || "",
          btn_link: data.btn_link || "",
        });
        setCurrentImages({
          bg_image: data.bg_image || "",
          image1: data.image1 || "",
          image2: data.image2 || "",
          image3: data.image3 || "",
          second_bg_image: data.second_bg_image || "",
        offer_bg_image: data.offer_bg_image || "",
        });
      } else {
        toast.error("Error fetching about content data.");
      }
    } catch (error) {
      console.error("Error fetching about content:", error);
      toast.error("Failed to fetch about content!");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type (check if it's an image)
      if (!file.type.startsWith("image/")) {
        alert("Please upload a valid image file.");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [e.target.id]: file,
        }));
        setCurrentImages((prevCurrentImages) => ({
          ...prevCurrentImages,
          [e.target.id]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    const form = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        form.append(key, formData[key]);
      }
    });    

    try {
      const response = await EditAboutContentApi(id, form);
      toast.success("Updated successfully!");
      console.log("Updated data:", response.data);
    } catch (error) {
      toast.error("Failed to update. Please try again.");
    }
  };

  return (
    <>
      <div>
        <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
          <h2 className="text-center text-3xl font-bold mb-5 mt-2">About Us Content</h2>
          <hr className="mb-4" />
          <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
            {/* Image Uploads */}
            {/* Background image*/}
            <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
              <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
                {currentImages.bg_image && (
                  <img
                    src={currentImages.bg_image}
                    alt="Current Background Image"
                    className="rounded shadow-md"
                    style={{ height: "130px", width: "150px" }}
                  />
                )}
              </div>
              <div className="sm:w-1/2 text-center">
                <label htmlFor="bg_image" className="block font-medium text-gray-900 mb-2">
                  Background image
                </label>
                <input
                  type="file"
                  id="bg_image"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById("bg_image").click()}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
                >
                  <MdUpload />
                </button>
                <p className="mt-2" style={{ fontSize: '10px' }}>The height and width must be 1300 × 731</p>

              </div>
            </div>

            {/* Heading */}
            <div className="sm:col-span-2">
              <label htmlFor="heading" className="block font-medium text-gray-900">Heading</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="heading"
                  id="heading"
                  value={formData.heading}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white" 
                />
              </div>
            </div>

            {/*Main Sub Heading */}
            <div className="sm:col-span-2">
              <label htmlFor="main_sub_heading" className="block font-medium text-gray-900">Main Sub Heading</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_sub_heading"
                  id="main_sub_heading"
                  value={formData.main_sub_heading}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main Heading1 */}
            <div className="sm:col-span-2">
              <label htmlFor="main_heading1" className="block font-medium text-gray-900">Main Heading1</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_heading1"
                  id="main_heading1"
                  value={formData.main_heading1}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/* Main Heading2 */}
            <div className="sm:col-span-2">
              <label htmlFor="main_heading2" className="block font-medium text-gray-900">Main Heading2</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_heading2"
                  id="main_heading2"
                  value={formData.main_heading2}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/* Main Heading3 */}
            <div className="sm:col-span-2">
              <label htmlFor="main_heading3" className="block font-medium text-gray-900">Main Heading3</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_heading3"
                  id="main_heading3"
                  value={formData.main_heading3}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/* Main Bottom Head */}
            <div className="sm:col-span-2">
              <label htmlFor="main_bottom_head" className="block font-medium text-gray-900">Main Bottom Head</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_bottom_head"
                  id="main_bottom_head"
                  value={formData.main_bottom_head}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*Main Description */}
            <div className="sm:col-span-4">
              <label htmlFor="main_description_section1" className="block font-medium text-gray-900">Main Description</label>
              <div className="mt-2">
                <textarea
                  name="main_description_section1"
                  id="main_description_section1"
                  value={formData.main_description_section1}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*Main Description Read-More*/}
            <div className="sm:col-span-4">
              <label htmlFor="main_description_read_more" className="block font-medium text-gray-900">Main Description Read-More</label>
              <div className="mt-2">
                <textarea
                  name="main_description_read_more"
                  id="main_description_read_more"
                  value={formData.main_description_read_more}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Image 1 */}
            <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
              <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
                {currentImages.image1 && (
                  <img
                    src={currentImages.image1}
                    alt="Current Image 1"
                    className="rounded shadow-md"
                    style={{ height: "130px", width: "150px" }}
                  />
                )}
              </div>
              <div className="sm:w-1/2 text-center">
                <label htmlFor="image1" className="block font-medium text-gray-900 mb-2">Image 1</label>
                <input
                  type="file"
                  id="image1"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById("image1").click()}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
                >
                  <MdUpload />
                </button>
                <p className="mt-2" style={{ fontSize: '10px' }}>The height and width must be 391 × 411</p>

              </div>
            </div>

            {/* Image 2 */}
            <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
              <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
                {currentImages.image2 && (
                  <img
                    src={currentImages.image2}
                    alt="Current Image 2"
                    className="rounded shadow-md"
                    style={{ height: "130px", width: "150px" }}
                  />
                )}
              </div>
              <div className="sm:w-1/2 text-center">
                <label htmlFor="image2" className="block font-medium text-gray-900 mb-2">Image 2</label>
                <input
                  type="file"
                  id="image2"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById("image2").click()}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
                >
                  <MdUpload />
                </button>
                <p className="mt-2" style={{ fontSize: '10px' }}>The height and width must be 265 × 274</p>

              </div>
            </div>
            {/* Image 3 */}
            <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
              <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
                {currentImages.image3 && (
                  <img
                    src={currentImages.image3}
                    alt="Current Image 3"
                    className="rounded shadow-md"
                    style={{ height: "130px", width: "150px" }}
                  />
                )}
              </div>
              <div className="sm:w-1/2 text-center">
                <label htmlFor="image3" className="block font-medium text-gray-900 mb-2">Image 3</label>
                <input
                  type="file"
                  id="image3"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById("image3").click()}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
                >
                  <MdUpload />
                </button>
                <p className="mt-2" style={{ fontSize: '10px' }}>The height and width must be 265 × 274</p>

              </div>
            </div>
            {/*Second Sub Heading */}
            <div className="sm:col-span-2">
              <label htmlFor="second_sub_head" className="block font-medium text-gray-900">Second Sub Heading</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="second_sub_head"
                  id="second_sub_head"
                  value={formData.second_sub_head}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/*Second Main Sub Heading1 */}
            <div className="sm:col-span-2">
              <label htmlFor="second_main_head1" className="block font-medium text-gray-900">Second Main Sub Heading1</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="second_main_head1"
                  id="second_main_head1"
                  value={formData.second_main_head1}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/*Second Main Sub Heading2 */}
            <div className="sm:col-span-2">
              <label htmlFor="second_main_head2" className="block font-medium text-gray-900">Second Main Sub Heading2</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="second_main_head2"
                  id="second_main_head2"
                  value={formData.second_main_head2}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/*Second Main Sub Heading3 */}
            <div className="sm:col-span-2">
              <label htmlFor="second_main_head3" className="block font-medium text-gray-900">Second Main Sub Heading3</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="second_main_head3"
                  id="second_main_head3"
                  value={formData.second_main_head3}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/* Second Background Image */}
    <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
      <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
        {currentImages.second_bg_image && (
          <img
            src={currentImages.second_bg_image}
            alt="Current Second Background Image"
            className="rounded shadow-md"
            style={{ height: "130px", width: "150px" }}
          />
        )}
      </div>
      <div className="sm:w-1/2 text-center">
        <label htmlFor="second_bg_image" className="block font-medium text-gray-900 mb-2">
          Second Background Image
        </label>
        <input
          type="file"
          id="second_bg_image"
          accept="image/*"
          className="hidden"
          onChange={handleImageUpload}
        />
        <button
          type="button"
          onClick={() => document.getElementById("second_bg_image").click()}
          className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
        >
          Upload
        </button>
        <p className="mt-2" style={{ fontSize: '10px' }}>The height and width must be 1920 × 543</p>

      </div>
    </div>

    {/* Offer Background Image */}
    <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
      <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
        {currentImages.offer_bg_image && (
          <img
            src={currentImages.offer_bg_image}
            alt="Current Offer Background Image"
            className="rounded shadow-md"
            style={{ height: "130px", width: "150px" }}
          />
        )}
      </div>
      <div className="sm:w-1/2 text-center">
        <label htmlFor="offer_bg_image" className="block font-medium text-gray-900 mb-2">
          Offer Background Image
        </label>
        <input
          type="file"
          id="offer_bg_image"
          accept="image/*"
          className="hidden"
          onChange={handleImageUpload}
        />
        <button
          type="button"
          onClick={() => document.getElementById("offer_bg_image").click()}
          className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
        >
          Upload
        </button>
        <p className="mt-2" style={{ fontSize: '10px' }}>The height and width must be 5760 × 3840</p>

      </div>
    </div>
            {/*Offer Heading */}
            <div className="sm:col-span-2">
              <label htmlFor="offer_head" className="block font-medium text-gray-900">Offer Heading</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="offer_head"
                  id="offer_head"
                  value={formData.offer_head}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*Offer Sub Heading */}
            <div className="sm:col-span-2">
              <label htmlFor="offer_sub_head" className="block font-medium text-gray-900">Offer Sub Heading</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="offer_sub_head"
                  id="offer_sub_head"
                  value={formData.offer_sub_head}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/*Offer Sub Heading2 */}
            <div className="sm:col-span-2">
              <label htmlFor="offer_head_two" className="block font-medium text-gray-900">Offer Sub Heading2</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="offer_head_two"
                  id="offer_head_two"
                  value={formData.offer_head_two}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/* Button Content */}
            <div className="sm:col-span-2">
              <label htmlFor="btn_content" className="block font-medium text-gray-900">Button Content</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="btn_content"
                  id="btn_content"
                  value={formData.btn_content}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Button Link */}
            <div className="sm:col-span-2">
              <label htmlFor="btn_link" className="block font-medium text-gray-900">Button Link</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="btn_link"
                  id="btn_link"
                  value={formData.btn_link}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
          </div>
          <hr className="mt-5 mb-5" />
          <div className="flex justify-center">
            <button
              type="button"
              onClick={handleUpdate}
              className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    
    </>
  );
}

export default AboutContent;
